/** @file Converts an absolute channel value to the setup-relative value stored in timelines. */
import type { Doc } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';

/** Returns the timeline value for an absolute value of `channel` on bone `boneId`. */
export function relativeToSetup(doc: Doc, boneId: string, channel: 'rotation' | 'x' | 'y' | 'scaleX' | 'scaleY' | 'shearX' | 'shearY', absolute: number): number {
  const bone = doc.bones[boneId] ?? throwError('NOT_FOUND', { kind: 'bone', ref: boneId });
  const setup = bone.setup[channel];
  if (channel !== 'scaleX' && channel !== 'scaleY') return absolute - setup;
  if (setup === 0) return throwError('VALIDATION', undefined, { path: 'value', hint: `setup ${channel} of bone ${bone.name} is 0, so a ${channel} key cannot be relative to it` });
  return absolute / setup;
}
